import {
  Module,
  VuexModule,
  Action,
  Mutation,
  getModule
} from 'vuex-module-decorators'
import Vue from 'vue'
import axios from 'axios'

import store from '@/store'
import dashboardModule from '@/store/dashboard'
import listModule from '@/store/list'
import whitelabelModule from '@/store/whitelabel'
import { Tag } from '@/types/Tag'
import { Whitelabel } from '@/types/Whitelabel'

const name = 'tag'

@Module({
  namespaced: true,
  dynamic: true,
  name,
  store
})
class TagModule extends VuexModule {
  private currentTag?: Tag
  private allTags: Tag[] = []

  private get whitelabel(): Whitelabel {
    return whitelabelModule.whitelabel
  }

  get tag(): Tag | undefined {
    return this.currentTag
  }

  get tags(): Tag[] {
    return this.allTags
  }


  @Mutation
  setCurrentTag(payload: Tag) {
    Vue.set(this, 'currentTag', payload)
  }

  @Mutation
  setAllTags(payload: Tag[]) {
    Vue.set(this, 'allTags', payload)
  }

  @Action({ rawError: true })
  async fetch(id: string) {
    try {
      const { data } = await axios.get(
        `/admin/${this.whitelabel.slug}/tag/${id}`
      )
      this.context.commit('setCurrentTag', data)
    } catch (error) {
      dashboardModule.newError('Tag konnte nicht geladen werden')
    }
  }

  @Action({ rawError: true })
  async fetchAll(params: {
    limit: number
    q?: string
    page?: number
    sortBy?: string
    sortDesc?: boolean
  }) {
    try {
      const { data } = await axios.get(
        `/admin/${this.whitelabel.slug}/tag/list`,
        {
          params
        }
      )
      this.context.commit('setAllTags', data.tags)
    } catch (error) {
      dashboardModule.newError('Tags konnten nicht geladen werden')
    }
  }

  @Action({ rawError: true })
  async create(tag: any) {
    try {
      const { data } = await axios.post(
        `/admin/${tag.whitelabel}/tag`,
        tag
      )
      this.context.commit('setCurrentTag', data)
      this.fetchAll({ limit: listModule.perPage })
      dashboardModule.newMessage('Tag wurde erfolgreich erstellt')
    } catch (error) {
      dashboardModule.newError('Tag konnte nicht erstellt werden')
    }
  }


  @Action({ rawError: true })
  async update(tag: Partial<Tag>) {
    try {
      const { data } = await axios.put(
        `/admin/${tag.whitelabel}/tag/${tag._id}`,
        tag
      )
      this.context.commit('setCurrentTag', data.tag)
      this.fetchAll({ limit: listModule.perPage })
      dashboardModule.newMessage('Tag wurde erfolgreich aktualisiert')
    } catch (error) {
      dashboardModule.newError('Tag konnte nicht aktualisiert werden')
    }
  }

  @Action({ rawError: true })
  setTag(payload: Tag) {
    this.context.commit('setCurrentTag', payload)
  }
}

export default getModule(TagModule)
